import { FC, ReactElement } from 'react'

import { SvgIconProps } from '@/components/Icon/Icon'

export const IconHome: FC<SvgIconProps> = ({ className = '' }): ReactElement => (
    <svg
        aria-hidden="true"
        className={`icon-component ${className}`}
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path className="stroke" d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline className="stroke" points="9 22 9 12 15 12 15 22" />
    </svg>
)
